@use 'sass:map';
@use './color';

/* stylelint-disable-next-line selector-pseudo-class-no-unknown */
:export {
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color23: #{color.$color-23};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color100: #{map.get(color.$color-map, 'color-100')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color101: #{map.get(color.$color-map, 'color-101')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color102: #{map.get(color.$color-map, 'color-102')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color103: #{map.get(color.$color-map, 'color-103')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color104: #{map.get(color.$color-map, 'color-104')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color105: #{map.get(color.$color-map, 'color-105')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color106: #{map.get(color.$color-map, 'color-106')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color107: #{map.get(color.$color-map, 'color-107')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color108: #{map.get(color.$color-map, 'color-108')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color109: #{map.get(color.$color-map, 'color-109')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color110: #{map.get(color.$color-map, 'color-110')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color111: #{map.get(color.$color-map, 'color-111')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color112: #{map.get(color.$color-map, 'color-112')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color113: #{map.get(color.$color-map, 'color-113')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color114: #{map.get(color.$color-map, 'color-114')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color115: #{map.get(color.$color-map, 'color-115')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color116: #{map.get(color.$color-map, 'color-116')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color117: #{map.get(color.$color-map, 'color-117')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color118: #{map.get(color.$color-map, 'color-118')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color119: #{map.get(color.$color-map, 'color-119')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color120: #{map.get(color.$color-map, 'color-120')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color121: #{map.get(color.$color-map, 'color-121')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color122: #{map.get(color.$color-map, 'color-122')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color123: #{map.get(color.$color-map, 'color-123')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color124: #{map.get(color.$color-map, 'color-124')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color125: #{map.get(color.$color-map, 'color-125')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color126: #{map.get(color.$color-map, 'color-126')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color127: #{map.get(color.$color-map, 'color-127')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color128: #{map.get(color.$color-map, 'color-128')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color129: #{map.get(color.$color-map, 'color-129')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color130: #{map.get(color.$color-map, 'color-130')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color131: #{map.get(color.$color-map, 'color-131')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color132: #{map.get(color.$color-map, 'color-132')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color133: #{map.get(color.$color-map, 'color-133')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color134: #{map.get(color.$color-map, 'color-134')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color135: #{map.get(color.$color-map, 'color-135')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color136: #{map.get(color.$color-map, 'color-136')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color137: #{map.get(color.$color-map, 'color-137')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color138: #{map.get(color.$color-map, 'color-138')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color139: #{map.get(color.$color-map, 'color-139')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color140: #{map.get(color.$color-map, 'color-140')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color141: #{map.get(color.$color-map, 'color-141')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color142: #{map.get(color.$color-map, 'color-142')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color143: #{map.get(color.$color-map, 'color-143')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color144: #{map.get(color.$color-map, 'color-144')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color145: #{map.get(color.$color-map, 'color-145')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color146: #{map.get(color.$color-map, 'color-146')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color147: #{map.get(color.$color-map, 'color-147')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color148: #{map.get(color.$color-map, 'color-148')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color149: #{map.get(color.$color-map, 'color-149')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color150: #{map.get(color.$color-map, 'color-150')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color151: #{map.get(color.$color-map, 'color-151')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color152: #{map.get(color.$color-map, 'color-152')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color153: #{map.get(color.$color-map, 'color-153')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color154: #{map.get(color.$color-map, 'color-154')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color155: #{map.get(color.$color-map, 'color-155')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color156: #{map.get(color.$color-map, 'color-156')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color157: #{map.get(color.$color-map, 'color-157')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color158: #{map.get(color.$color-map, 'color-158')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color159: #{map.get(color.$color-map, 'color-159')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color160: #{map.get(color.$color-map, 'color-160')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color161: #{map.get(color.$color-map, 'color-161')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color162: #{map.get(color.$color-map, 'color-162')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color163: #{map.get(color.$color-map, 'color-163')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color164: #{map.get(color.$color-map, 'color-164')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color165: #{map.get(color.$color-map, 'color-165')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color166: #{map.get(color.$color-map, 'color-166')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color167: #{map.get(color.$color-map, 'color-167')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color168: #{map.get(color.$color-map, 'color-168')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color169: #{map.get(color.$color-map, 'color-169')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color170: #{map.get(color.$color-map, 'color-170')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color171: #{map.get(color.$color-map, 'color-171')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color172: #{map.get(color.$color-map, 'color-172')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color173: #{map.get(color.$color-map, 'color-173')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color174: #{map.get(color.$color-map, 'color-174')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color175: #{map.get(color.$color-map, 'color-175')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color176: #{map.get(color.$color-map, 'color-176')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color177: #{map.get(color.$color-map, 'color-177')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color178: #{map.get(color.$color-map, 'color-178')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color179: #{map.get(color.$color-map, 'color-179')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color180: #{map.get(color.$color-map, 'color-180')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color181: #{map.get(color.$color-map, 'color-181')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color182: #{map.get(color.$color-map, 'color-182')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color183: #{map.get(color.$color-map, 'color-183')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color184: #{map.get(color.$color-map, 'color-184')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color185: #{map.get(color.$color-map, 'color-185')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color186: #{map.get(color.$color-map, 'color-186')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color187: #{map.get(color.$color-map, 'color-187')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color188: #{map.get(color.$color-map, 'color-188')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color189: #{map.get(color.$color-map, 'color-189')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color190: #{map.get(color.$color-map, 'color-190')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color191: #{map.get(color.$color-map, 'color-191')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color192: #{map.get(color.$color-map, 'color-192')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color193: #{map.get(color.$color-map, 'color-193')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color194: #{map.get(color.$color-map, 'color-194')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color195: #{map.get(color.$color-map, 'color-195')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color196: #{map.get(color.$color-map, 'color-196')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color197: #{map.get(color.$color-map, 'color-197')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color198: #{map.get(color.$color-map, 'color-198')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color199: #{map.get(color.$color-map, 'color-199')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color200: #{map.get(color.$color-map, 'color-200')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color201: #{map.get(color.$color-map, 'color-201')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color202: #{map.get(color.$color-map, 'color-202')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color203: #{map.get(color.$color-map, 'color-203')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color204: #{map.get(color.$color-map, 'color-204')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color205: #{map.get(color.$color-map, 'color-205')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color206: #{map.get(color.$color-map, 'color-206')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color207: #{map.get(color.$color-map, 'color-207')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color208: #{map.get(color.$color-map, 'color-208')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color209: #{map.get(color.$color-map, 'color-209')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color210: #{map.get(color.$color-map, 'color-210')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color211: #{map.get(color.$color-map, 'color-211')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color212: #{map.get(color.$color-map, 'color-212')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color213: #{map.get(color.$color-map, 'color-213')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color214: #{map.get(color.$color-map, 'color-214')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color215: #{map.get(color.$color-map, 'color-215')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color216: #{map.get(color.$color-map, 'color-216')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color217: #{map.get(color.$color-map, 'color-217')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color218: #{map.get(color.$color-map, 'color-218')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color219: #{map.get(color.$color-map, 'color-219')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color220: #{map.get(color.$color-map, 'color-220')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color221: #{map.get(color.$color-map, 'color-221')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color222: #{map.get(color.$color-map, 'color-222')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color223: #{map.get(color.$color-map, 'color-223')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color224: #{map.get(color.$color-map, 'color-224')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color225: #{map.get(color.$color-map, 'color-225')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color226: #{map.get(color.$color-map, 'color-226')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color227: #{map.get(color.$color-map, 'color-227')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color228: #{map.get(color.$color-map, 'color-228')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color229: #{map.get(color.$color-map, 'color-229')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color230: #{map.get(color.$color-map, 'color-230')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color231: #{map.get(color.$color-map, 'color-231')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color232: #{map.get(color.$color-map, 'color-232')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color233: #{map.get(color.$color-map, 'color-233')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color234: #{map.get(color.$color-map, 'color-234')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color235: #{map.get(color.$color-map, 'color-235')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color236: #{map.get(color.$color-map, 'color-236')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color237: #{map.get(color.$color-map, 'color-237')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  color238: #{map.get(color.$color-map, 'color-238')};

  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen001: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen001')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen002: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen002')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen003: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen003')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen004: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen004')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen005: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen005')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen006: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen006')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen007: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen007')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen008: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen008')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen009: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen009')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen010: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen010')};
  /* stylelint-disable-next-line property-case,property-no-unknown */
  chartBlindColorColorblindredgreen011: #{map.get(color.$color-blind-map, 'chart-blind-color-colorblindredgreen011')};
}